import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { AngleRight } from '@alefeducation/ui-elements-library-icons';
import React from 'react';
import { Heading } from '@alefeducation/ui-elements-library-core';

interface HeadingWithIconProps {
  path: string;
  children: string;
}

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
`;

const StyledHeading = styled(Heading)`
  cursor: pointer;
`;

const HeadingWithIcon = ({ path, children }: HeadingWithIconProps) => {
  const history = useHistory();

  return (
    <StyledContainer>
      <span
        onClick={() => {
          history.push(path);
        }}
      >
        <StyledHeading
          variant="heading-small"
          color="primary.100"
          weight="light"
        >
          {children}
        </StyledHeading>
      </span>
      <AngleRight height="12" width="12" color="primary.100" />
    </StyledContainer>
  );
};

export default HeadingWithIcon;
